import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { LanguageService } from 'src/app/core/services/language.service';
import { RootReducerState } from 'src/app/modals';
import { getUser } from 'src/app/modals/Authentication/authentication-selector';

@Component({
  // selector: '<body[root]>',
  selector: 'auth-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslateModule], 
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css'
})

export class AuthComponent implements OnInit, OnDestroy {

  today: Date = new Date();
  year: number = new Date().getFullYear();
  user$: Observable<any>;
  private destroy$ = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
    public languageService: LanguageService,
    public translate: TranslateService,
    public store: Store<RootReducerState>,
  ) {}

  // ngAfterViewInit(): void {
  //     this.elementRef.nativeElement.ownerDocument
  //           .body.style.backgroundColor = '#000f55';
  // }

  ngOnInit(): void {

    this.store.select(getUser)
                .pipe(takeUntil(this.destroy$))
                .subscribe((getUser) => {
                  //Change made in user
                  if(getUser){
                    //User has been updated, It does not get triggered when the request fails
                    this.languageService.checkAndSet(getUser.lang)
                  }
                });

    // BODY_CLASSES.forEach((c) => document.body.classList.add(c));
  }

  ngOnDestroy() {
    // BODY_CLASSES.forEach((c) => document.body.classList.remove(c));
    this.destroy$.next();
    this.destroy$.complete();
  }

}
